const initialState = {
  notificationBadge: '',
};

export default initialState;
